import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	assigneeColumnHeader: {
		id: 'backlog.card-list.work-load-by-assignee.summary-modal.summary-table.summary-table-header.assignee-column-header',
		defaultMessage: 'Assignee',
		description: 'Column header for assignees',
	},
	issueCountColumnHeader: {
		id: 'backlog.card-list.work-load-by-assignee.summary-modal.summary-table.summary-table-header.issue-count-column-header',
		defaultMessage: 'Issues',
		description: 'Column header for issue counts',
	},
	remainingEstimateColumnHeader: {
		id: 'backlog.card-list.work-load-by-assignee.summary-modal.summary-table.summary-table-header.remaining-estimate-column-header',
		defaultMessage: 'Remaining time estimate',
		description: 'Column header for remaining time estimates',
	},
	subtasksColumnHeader: {
		id: 'backlog.card-list.work-load-by-assignee.summary-modal.summary-table.summary-table-header.subtasks-column-header',
		defaultMessage: 'Subtasks',
		description: 'Column header for subtasks count',
	},
});
